import { render, staticRenderFns } from "./Alertes.vue?vue&type=template&id=fefb5082&"
import script from "./Alertes.vue?vue&type=script&lang=js&"
export * from "./Alertes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports